import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { useFormikContext } from 'formik';

export const ClearButton: React.FC<any> = (props) => {
    const { name } = props; 
    const { values, setFieldValue } = useFormikContext<any>();
    const value = values && values[name] || ''; // Get the current value of the field

    const handleClear = () => {
        setFieldValue(name, ''); // Clear the field value
    };

    return (
        value && value.length > 0 && ( // Render only if value exists
            <FontAwesomeIcon
                icon={faTimesCircle}
                className="text-gray-400 cursor-pointer hover:text-red-500"
                onClick={handleClear}
                {...props} // Spread props for future extensibility
            />
        )
    );
};